export const API_MODULES = {
  COUPONS: 'coupons',
  LOCAL: 'local',
  AUTH: 'auth',
  ADMINISTRATION: 'administration',
  ACCOUNTS: 'accounts',
  ADDRESSES: 'addresses',
  CATALOG: 'catalog',
  CHECKOUT: 'checkout',
  PAYMENT_SETTINGS: 'payment-settings',
  SHIPPING_SETTINGS: 'shipping-settings',
  INVENTORY: 'inventory',
  ORDERS: 'orders',
  STORES: 'stores',
  MARKETPLACE: 'marketplace',
  CART: 'cart',
  FINANCE: 'finance',
  PRODUCTS: 'products',
  DECKS: 'decks',
  PROMOTIONS: 'promotions',
};
